import React, { useState, useEffect } from 'react'
import { Menu, X } from 'lucide-react'
import { NAV_LINKS, IMAGES } from '../constants'

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20)
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <header
      className={`fixed z-50 w-full transition-all duration-300 ${
        isScrolled
          ? 'border-b border-black/5 bg-white/95 shadow-md backdrop-blur-xl'
          : 'border-b border-black/5 bg-white/80 backdrop-blur-lg'
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-20 items-center justify-between">
          {/* Logo */}
          <div className="flex flex-shrink-0 items-center">
            <a
              href="#"
              className="flex items-center rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2"
            >
              <img src={IMAGES.logo} alt="Bavarian Real Estate Logo" className="h-10 w-auto" />
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden space-x-8 md:flex">
            {NAV_LINKS.map((link) => (
              <a
                key={link.id}
                href={link.href}
                className="link-underline relative rounded px-1 font-medium text-text-primary transition-colors hover:text-accent focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden items-center md:flex">
            <a
              href="#contacto"
              className="group rounded-lg bg-primary px-6 py-2.5 font-medium text-white transition-all duration-300 hover:bg-primary-light hover:text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2"
            >
              Agendar llamada
              <span className="btn-arrow ml-1 inline-block">→</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="flex items-center md:hidden">
            <button
              type="button"
              className="rounded p-2 text-text-primary hover:text-accent focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2"
              onClick={() => setIsOpen(!isOpen)}
              aria-expanded={isOpen}
              aria-controls="mobile-menu"
              aria-label={isOpen ? 'Cerrar menú' : 'Abrir menú'}
            >
              {isOpen ? (
                <X className="h-6 w-6" aria-hidden={true} />
              ) : (
                <Menu className="h-6 w-6" aria-hidden={true} />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isOpen && (
        <div id="mobile-menu" className="border-t border-border-light bg-white md:hidden">
          <div className="space-y-1 px-4 pb-4 pt-2">
            {NAV_LINKS.map((link) => (
              <a
                key={link.id}
                href={link.href}
                onClick={() => setIsOpen(false)}
                className="block rounded px-3 py-3 font-medium text-text-primary hover:text-accent focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contacto"
              onClick={() => setIsOpen(false)}
              className="mt-4 block rounded-lg bg-primary px-6 py-3 text-center font-medium text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2"
            >
              Agendar llamada
            </a>
          </div>
        </div>
      )}
    </header>
  )
}

export default Navbar
